import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SkillRepositoryService {
  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  public competencydata={};
  constructor(private http: HttpClient) { }

   private sharedVariableSource = new BehaviorSubject<any>(null);
    sharedVariable$ = this.sharedVariableSource.asObservable();

  public getAllCompetenciesWithCount(searchText: any) {
    const url = `${this.apiUrl}Competency/GetAllCompetenciesWithCount?search=${searchText}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetEmployeesCountByCompetency(searchText: any){
    const url = `${this.apiUrl}Profile/GetEmployeesCountByCompetency?search=${searchText}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetResourceCountBySubCompetency(compId:any | null){
    const url = `${this.apiUrl}Profile/GetEmployeesCountBySubCompetency?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetResourceCountBySubCompetency1(){
    const url = `${this.apiUrl}Profile/GetEmployeesCountBySubCompetency`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getcompetencydetails(data: any)
  { 
    
     return {};
  }
  updateSharedVariable(newValue: any): void {
    this.sharedVariableSource.next(newValue);
  }
}





